import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import * as XLSX from 'xlsx';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from '../../../constants/constants';
const useStyles = makeStyles(({
  containerForm: {
    display: 'flex',
    flexDirection: 'column'
  },
  input: {
    display: 'none'
  },
  labelInput: {
    cursor: 'pointer',
    width: '100%',
    padding: '16px',
    marginTop: '16px',
    textAlign: 'center',
    borderColor: '#019592',
    borderStyle: 'dashed',
    borderWidth: '2px',
    marginBottom: '8px'
  },
  containerButton: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    marginTop: '16px'
  }
}));
const FILE_TYPES_ACCEPTED = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.odt', '.ods', '.odp'];

const FormFileAttachments = ({ data, onChange, setExcelData }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [typeError, setTypeError] = useState(null);
  const { step2: { workbook } } = data;

  const checkFileExtension = (file) => {
    const ext = /[.]\w{3,4}$/.exec(file.name)[0];
    if (!ext || !FILE_TYPES_ACCEPTED.includes(ext)) {
      return false;
    }
    return true;
  };
  const getNumberOfRowsInExcel = () => {
    const worksheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[worksheetName];

    let rowCount = 0;
    for (const cell in worksheet) {
      if (cell[0] === 'A' && !isNaN(cell.substring(1))) {
        rowCount++;
      }
    }

    return rowCount - 1;
  };
  const fillExcelFile = (files) => {
    const worksheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[worksheetName];

    let emptyColumn = 'A';
    let row = 1; // Comenzamos desde la primera fila

    while (worksheet[`${emptyColumn}${row}`]) {
      if (worksheet[`${emptyColumn}${row}`].v === 'attachmentName') {
        break;
      }
      emptyColumn = String.fromCharCode(emptyColumn.charCodeAt(0) + 1);
    }
    const arrayOfNameFiles = [];
    for (let i = 0; i < files.length; i++) {
      arrayOfNameFiles.push([files[i].name]);
    }
    const arrayToWrite = [['attachmentName']].concat(arrayOfNameFiles);

    XLSX.utils.sheet_add_aoa(worksheet, arrayToWrite, { origin: `${emptyColumn}1` });

    const excelData = XLSX.utils.sheet_to_json(worksheet, { range: `A1:${emptyColumn}${files.length + 1}` });

    setExcelData(excelData);
    return excelData;
  };
  const checkFilesSize = (files) => {
    let totalSize = 0;

    for (let i = 0; i < files.length; i++) {
      totalSize += files[i].size;
    }
    return totalSize;
  };
  const handleFile = (e) => {
    const imageName = document.getElementById('nameFileSlected');
    let selectedFile = e.target.files[0];
    if (selectedFile) {
      imageName.innerText = t('wizardBulkNotification:filesUploaded');
    }
    e.persist();
    // CHECK FILE EXTENSION
    for (let i = 0; i < e.target.files.length; i++) {
      const fileExtension = checkFileExtension(e.target.files[i]);
      if (!fileExtension) {
        setTypeError('Wrong Extension', `${t('docUpdate:extensionError')} ${FILE_TYPES_ACCEPTED.join(', ')}`);
        return;
      }
    }
    // CHECK NUMBER OF FILES
    const maxOrMinFiles = getNumberOfRowsInExcel();
    if (e.target.files.length !== maxOrMinFiles) {
      setTypeError(t('wizardBulkNotification:numAttachments') + `${maxOrMinFiles}.`);
      return;
    }
    // CHECK FILES SIZE
    const totalSize = checkFilesSize(e.target.files);
    if (totalSize > CONSTANTS.DEFAULT_FILE_SIZE.BULK_NOTIFICATION) {
      setTypeError('Max file size excedded (5MB)', t('docUpload:fileSizeExcceded'));
      return;
    }
    setTypeError(null);

    // FILL EXCEL FILE
    const excelData = fillExcelFile(e.target.files);

    onChange((prv) => ({ ...prv,
      step2: {
        oldExcelData: prv.step2.excelData,
        workbook,
        excelData

      },
      step3: { attachmentFiles: e.target.files }
    }));
  };
  return (
    <form className={classes.containerForm}>
      <label htmlFor='file' className={classes.labelInput}>
        {t('wizardBulkNotification:selecteFile')}
        <input id='file' className={classes.input} type='file' required onChange={handleFile} multiple />
        <br />
        <strong id='nameFileSlected' />
      </label>
      {typeError && (
        <div role='alert'>{typeError}</div>
      )}
    </form>
  );
};
FormFileAttachments.propTypes = {
  onChange: PropTypes.func.isRequired,
  setExcelData: PropTypes.func.isRequired
};
export default FormFileAttachments;
